import isAuthenticatedSigninGuard  from './not-auth-guard'
export default {
    name:'auth',
    beforeEnter: [ isAuthenticatedSigninGuard ],
    component: () => import(/* webpackChunkName: "Auth Layout" */ '@/auth/layouts/Signin.vue')
}